import { render, staticRenderFns } from "./AddManage.vue?vue&type=template&id=4f8e9c4c&scoped=true&"
import script from "./AddManage.vue?vue&type=script&lang=js&"
export * from "./AddManage.vue?vue&type=script&lang=js&"
import style0 from "./AddManage.vue?vue&type=style&index=0&id=4f8e9c4c&lang=less&scoped=true&"
import style1 from "./AddManage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e9c4c",
  null
  
)

export default component.exports